import axios from 'axios'

const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    headers: {
        'Content-Type': 'application/json',
    },
})

const formatAuthorization = (idToken) =>
    idToken + '.' + btoa(JSON.stringify({ id: process.env.REACT_APP_ID }))

export default {
    getLogData: (idToken) =>
        new Promise((resolve, reject) => {
            console.debug(process.env.REACT_APP_API_URL)
            instance
                .post(
                    'reports/data-log',
                    {
                        init: true,
                    },
                    {
                        headers: {
                            Authorization: formatAuthorization(idToken),
                        },
                    }
                )
                .then((response) => {
                    if (response.status === 200) {
                        resolve(response.data)
                    } else {
                        reject(new Error("Couldn't retrieve data"))
                    }
                })
                .catch((error) => {
                    reject(error)
                })
        }),

    searchLogData: (idToken, params) =>
        new Promise((resolve, reject) => {
            console.debug(process.env.REACT_APP_API_URL)
            instance
                .post(
                    'reports/data-log',
                    {
                        search: true,
                        to: params.toDate,
                        from: params.fromDate,
                        application: params.application,
                        applicationType: params.applicationType
                    },
                    {
                        headers: {
                            Authorization: formatAuthorization(idToken),
                        },
                    }
                )
                .then((response) => {
                    if (response.status === 200) {
                        resolve(response.data)
                    } else {
                        reject(new Error("Couldn't retrieve data"))
                    }
                })
                .catch((error) => {
                    reject(error)
                })
        }),
}
